import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { InputMaskModule } from 'primeng/inputmask';

import { CommonBaseComponent } from '../common-base.component';

@Component({
  selector: 'app-input-mask',
  templateUrl: './input-mask.component.html',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    TranslateModule,
    TranslateModule,
    InputMaskModule,
  ],
})
export class InputMaskComponent extends CommonBaseComponent {
  constructor() {
    super();
  }
}
